import { memo } from 'react';
import { useLocation } from 'react-router-dom';

import HomeLogo from '@src/assets/images/home/home.png';

import { useRejoin } from '@src/hooks';
import { OButton } from '@src/shared';

import styles from './roomStatus.module.scss';

interface RoomStatusScreenProps {
  status: 'notFound' | 'ended';
}

const statusMap = {
  notFound: {
    header: 'Room does not exist',
    content: 'This meeting room doesn’t exist or has already ended',
    showTimer: false,
    img: HomeLogo,
  },
  ended: {
    header: 'The meeting has been ended',
    content: 'We hope you had a great session',
    showTimer: true,
    img: HomeLogo,
  },
};

const RoomStatusScreen = ({ status }: RoomStatusScreenProps) => {
  const location = useLocation();
  const roomType = location.state?.roomType || 'meeting';

  const { handleReturnHome, timeLeft, isMobileDevice } = useRejoin(true);

  const config = statusMap[status];

  return (
    <div className={styles.rejoinContainer}>
      <div className={styles.rejoinContentContainer}>
        <img src={config.img} alt="Status Logo" />
        <div className={styles.textContainer}>
          <p className={`${styles.textContainerHeader} ${isMobileDevice ? `${styles.headerFontSize}` : ''}`}>
            {status === 'ended' ? `The ${roomType} has been ended` : config.header}
          </p>
          <p className={styles.textContainerContent}>{config.content}</p>
        </div>
        <div className={styles.buttonContainer}>
          <OButton
            text="Return to home screen"
            onClick={handleReturnHome}
            size={isMobileDevice ? 'medium' : 'x-medium'}
          />
        </div>
        {config.showTimer && (
          <div className={styles.timerContainer}>
            <p className={styles.timerContainerText}>You'll be returning to the home screen within {timeLeft}'s</p>
          </div>
        )}
      </div>
      <div className={styles.footerContainer}>
        <p className={styles.footerContainerText}>Learn more about Meet</p>
      </div>
    </div>
  );
};

export default memo(RoomStatusScreen);
